"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M12 20a.587.587 0 0 1-.109-.01.511.511 0 0 1-.43-.49V15H8.77a.547.547 0 0 1-.45-.225.471.471 0 0 1-.045-.472l3.23-7a.545.545 0 0 1 .604-.293c.25.048.43.253.43.49V12h2.692a.55.55 0 0 1 .45.225c.1.141.116.318.046.472l-3.23 7A.543.543 0 0 1 12 20Zm-2.415-6H12c.297 0 .538.224.538.5v2.564L14.414 13H12c-.297 0-.539-.224-.539-.5V9.936L9.585 14Zm6.723 9H7.692C6.207 23 5 21.878 5 20.5v-14C5 5.122 6.207 4 7.692 4h1.616V2.5c0-.276.24-.5.538-.5h4.308c.297 0 .538.224.538.5V4h1.616C17.793 4 19 5.122 19 6.5v14c0 1.378-1.207 2.5-2.692 2.5ZM7.692 5c-.89 0-1.615.673-1.615 1.5v14c0 .827.725 1.5 1.615 1.5h8.616c.89 0 1.615-.673 1.615-1.5v-14c0-.827-.725-1.5-1.615-1.5h-2.154c-.297 0-.539-.224-.539-.5V3h-3.23v1.5c0 .276-.242.5-.539.5H7.692Z",
    clipRule: "evenodd"
  })]
});